import { HTTPInstanceWithPrefix } from '@/http/http-instance-with-prefix'
import { TablePutPayload } from './TablesAPI.model'

class TablesAPI {
  static putTableStatus = (
    tableId: string,
    payload: TablePutPayload
  ): Promise<void> =>
    HTTPInstanceWithPrefix.put(`/tables/${tableId}`, payload).then(
      response => response.data
    )
}

export default TablesAPI
